import { GridFilterOperator, GridValidRowModel } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { LabelledEntity } from 'shared/types/commonView';
import {
  createEntityArrayFilterPredicate,
  createEntityValueFilterPredicate,
} from '../common';
import { CustomFilterOperator } from './constants';

type OperatorFactory = (intl: IntlShape) => GridFilterOperator;

export const createContainsOperator = (
  inputComponent: GridFilterOperator['InputComponent']
): OperatorFactory => {
  return (intl: IntlShape): GridFilterOperator => ({
    label: formatTranslation(intl, FiltersTranslationKeys.operatorContains),
    value: CustomFilterOperator.CONTAINS,
    getApplyFilterFn: (filterItem) => createEntityArrayFilterPredicate(filterItem),
    InputComponent: inputComponent,
  });
};

export const createContainsDirectEntityOperator = (
  inputComponent: GridFilterOperator['InputComponent'],
  getValueFromRow: (row: GridValidRowModel) => LabelledEntity | null
): OperatorFactory => {
  return (intl: IntlShape): GridFilterOperator => ({
    label: formatTranslation(intl, FiltersTranslationKeys.operatorContains),
    value: CustomFilterOperator.CONTAINS,
    getApplyFilterFn: (filterItem) => {
      const fn = createEntityValueFilterPredicate<LabelledEntity>(filterItem);
      if (!fn) return null;
      return (_value: unknown, row: GridValidRowModel) => fn(getValueFromRow(row));
    },
    InputComponent: inputComponent,
  });
};
